export default "__VITE_ASSET__BZ6wmFAp__"